/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ orderNumber: NonNullable<unknown> }} Orders_Documents_TitleInputs */

const en_orders_documents_title = /** @type {(inputs: Orders_Documents_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Order Documents - #${i?.orderNumber}`)
};

const es_orders_documents_title = /** @type {(inputs: Orders_Documents_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Documentos del pedido - #${i?.orderNumber}`)
};

/**
* | output |
* | --- |
* | "Order Documents - #{orderNumber}" |
*
* @param {Orders_Documents_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_documents_title = /** @type {((inputs: Orders_Documents_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Documents_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_documents_title(inputs)
	return es_orders_documents_title(inputs)
});